import { useMutation } from "@apollo/client";
import { CREATE_GENERATION_TEMPLATE, GET_GENERATION_TEMPLATES } from "../gql";
import type {
  CreateGenerationTemplateInput,
  CreateGenerationTemplatePayload,
} from "@casey/db-types";

interface UseCreateGenerationTemplateResult {
  createTemplate: (
    input: CreateGenerationTemplateInput,
  ) => Promise<CreateGenerationTemplatePayload>;
  loading: boolean;
  error: Error | null;
}

export function useCreateGenerationTemplate(
  organizationId: string,
): UseCreateGenerationTemplateResult {
  const [mutate, { loading, error }] = useMutation<{
    createGenerationTemplate: CreateGenerationTemplatePayload;
  }>(CREATE_GENERATION_TEMPLATE, {
    refetchQueries: [
      {
        query: GET_GENERATION_TEMPLATES,
        variables: { organizationId },
      },
    ],
  });

  const createTemplate = async (
    input: CreateGenerationTemplateInput,
  ): Promise<CreateGenerationTemplatePayload> => {
    const result = await mutate({
      variables: { input },
    });

    if (!result.data?.createGenerationTemplate) {
      throw new Error("Failed to create template");
    }

    return result.data.createGenerationTemplate;
  };

  return {
    createTemplate,
    loading,
    error: error || null,
  };
}
